import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Checkbox } from "antd";

import waitersActions from "../../../redux/waiters/actions";
import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import "./index.css";

const { getWaiters, getTurnOverByWaiters } = waitersActions;
const { Option } = Select;

const WaitersInfoActions = () => {
  const dispatch = useDispatch();
  const [selectedWaiters, setSelectedWaiters] = useState(["all"]);
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
    showPaymentMethods,
    setShowPaymentMethods,
  } = useProjectState();

  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { waiters } = useSelector((state) => state.waitersReducer);

  let filteredIds = [];
  if (selectedWaiters.includes("all")) {
    filteredIds = waiters.map((item) => item.id);
  } else {
    filteredIds = selectedWaiters.map((name) => {
      const waiter = waiters.find((item) => item.name === name);
      return waiter ? waiter.id : null;
    });
  }

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    dispatch(getWaiters(defaultOrganization[0]?.defaultTouchSaleRestaurantId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  const firstSelectedWaiters = selectedWaiters[0];
  useEffect(() => {
    const timer = setTimeout(() => {
      if (filteredIds.length !== 0) {
        dispatch(getTurnOverByWaiters(filteredIds, startDate, endDate));
      }
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    startDate,
    endDate,
    filteredIds.length,
    waiters.length,
    firstSelectedWaiters,
  ]);

  const handleOnChangeRestaurant = (restaurant) => {
    setAllSelectedRestaurants([restaurant]);
    dispatch(getWaiters(restaurant));
  };

  const handleOnSelectWaiters = (waiter) => {
    if (waiter === "all") {
      setSelectedWaiters([waiter]);
    } else if (selectedWaiters.includes("all")) {
      setSelectedWaiters([waiter]);
    } else {
      setSelectedWaiters((prevSelectedWaiters) => [
        ...prevSelectedWaiters,
        waiter,
      ]);
    }
  };

  const handleDeSelectWaiters = (waiterToRemove) => {
    setSelectedWaiters((prevSelectedWaiters) => {
      return prevSelectedWaiters.filter(
        (waiter) => !waiterToRemove.includes(waiter)
      );
    });
  };

  return (
    <>
      <div className="waiters-info-action-buttons-container">
        {defaultOrganization[0]?.multipleRestaurants && (
          <Select
            showSearch={false}
            virtual={false}
            key="waitersInfoRestaurantSelect"
            placeholder="Изберете ресторант"
            onChange={handleOnChangeRestaurant}
            value={allSectedRestaurants}
            className="waiters-info-action-buttons"
          >
            {restaurants?.map((restaurant, index) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="waiters-info-select-option"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        )}
        <DatePickerComponent />
      </div>
      <div className="waiters-info-select-container">
        <Select
          disabled={allSectedRestaurants[0] === undefined}
          virtual={false}
          key="salesInfoWaiterSelect"
          mode="multiple"
          placeholder="Изберете сервитьори"
          onSelect={handleOnSelectWaiters}
          onDeselect={handleDeSelectWaiters}
          value={selectedWaiters}
          maxTagCount={6}
          className="waiters-info-select-waiters"
        >
          <Option key="all" value="all">
            Всички
          </Option>
          {waiters &&
            waiters.map((waiter) => (
              <Option key={waiter.name} value={waiter.name}>
                {waiter.name}
              </Option>
            ))}
        </Select>
        <Checkbox
          checked={showPaymentMethods}
          onChange={() => setShowPaymentMethods(!showPaymentMethods)}
          className="waiters-checkbox"
        >
          <p className="waiters-checkbox-text">Видове Плащания</p>
        </Checkbox>
      </div>
    </>
  );
};

export default WaitersInfoActions;
